module.exports = __webpack_public_path__ + "static/media/ic-export.3ed6aa45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-export.svg
// module id = 626
// module chunks = 14